import { Loader } from "dash-styled"
import { FC } from "react"
import { Redirect } from "react-router"
import { useBackofficeAdmin } from "../../../Hooks/useBackofficeAdmin"
import { hasValue } from "../../../Models/Client/FetchState"
import { routePaths } from "../../../Routes"

export const BackofficeAuthCheck: FC = ({ children }) => {
    const backofficeAdminFetch = useBackofficeAdmin()

    if (!hasValue(backofficeAdminFetch)) {
        return <Loader testId="backoffice-auth-check-loader" />
    }

    if (hasValue(backofficeAdminFetch) && backofficeAdminFetch.value === true) {
        return <>{children}</>
    }

    return <Redirect to={routePaths.dashboard()} />
}
